import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRoutes } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import wixService from '../services/wixService';

const Widget = dynamic(() =>
  import(/* webpackChunkName: 'widget' */ '../components/widget')
);
const Settings = dynamic(() =>
  import(/* webpackChunkName: 'settings' */ '../components/settings')
);
const Support = dynamic(() =>
  import(/* webpackChunkName: 'support' */ '../components/support')
);
// Style loader
import withEnhancedStyleLoader from '../withEnhancedStyleLoader';

const App = (props) => {
  const [tab, setTab] = useState('tab-1');

  useEffect(() => {
    const checkEditorMode = async () => {
      if (wixService.isEditorMode()) {
        const privateApi = await props.editorSDK.editor.getAppAPI();
        const currentTab = await privateApi.getActiveTab();
        console.log({ currentTab });

        switch (currentTab) {
          case 'DISPLAY':
            setTab('tab-2');
            break;
          case 'LAYOUT':
            setTab('tab-3');
            break;
          case 'DESIGN':
            setTab('tab-5');
            break;
          default:
            break;
        }
      }
    };

    checkEditorMode();
  }, [props.editorSDK.editor]);

  return useRoutes([
    {
      path: '/settings',
      element: <Settings tab={tab} />,
    },
    { path: '/support', element: <Support /> },
    { path: '/mobile', element: <Widget /> },
    { path: '/index', element: <Widget /> },
  ]);
};

export default withTranslation()(withEnhancedStyleLoader(App));
